











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddReflectTemplateMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectTemplate",
      "kind": "LinkedField",
      "name": "reflectTemplate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TemplateSharing_template"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReflectTemplateDetailsTemplate"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityDetails_template"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddReflectTemplatePayload",
  "abstractKey": null
};

(node ).hash = "31b8b20ba1a552973571d530f726335f";

export default node;
